<script setup lang="ts">
import { PhxCoreDivider } from '@sg-core/src/View/Components/Atoms/Divider';

import './divider.css';

defineProps({
  vertical: {
    type: Boolean,
    default: false,
  },

  spacing: {
    type: [Number, String],
    default: null,
  },

  color: {
    type: String,
    default: null,
  },
});
</script>

<template>
  <PhxCoreDivider
    :class="[
      'phxsg-divider',
      {
        'phxsg-divider--vertical': vertical,
        [`phxsg-divider--spacing-${spacing}`]: spacing,
        [`phxsg-divider--color-${color}`]: color,
      },
    ]"
  >
    <slot />
  </PhxCoreDivider>
</template>
